export default "__VITE_ASSET__CKIARaZu__"